import { render, staticRenderFns } from "./CustomNotificationWrapper.vue?vue&type=template&id=53d8c746&scoped=true&lang=pug&"
import script from "./CustomNotificationWrapper.vue?vue&type=script&lang=js&"
export * from "./CustomNotificationWrapper.vue?vue&type=script&lang=js&"
import style0 from "./CustomNotificationWrapper.vue?vue&type=style&index=0&id=53d8c746&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53d8c746",
  null
  
)

export default component.exports